import CryptoJS from 'crypto-js';
 
const ENCRYPTION_KEY = process.env.REACT_APP_SECRET_KEY; 

const IV_LENGTH = 16;
 
export function encryptObject(obj) {
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY.padEnd(32, '0')); 
  const iv = CryptoJS.lib.WordArray.random(IV_LENGTH);
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(obj), key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
 
  const encryptedData = encrypted.ciphertext.toString(CryptoJS.enc.Base64);
  const ivBase64 = iv.toString(CryptoJS.enc.Base64);
  return `${ivBase64}:${encryptedData}`;
}

export function decryptObject(encryptedString) {
  if (typeof encryptedString !== "string" || !encryptedString.trim()) {
    throw new Error("decryptObject: encryptedString must be a non-empty string");
  }

  encryptedString = encryptedString.trim();
  encryptedString = encryptedString.replace(/^"|"$/g, "");
  encryptedString = encryptedString.replace(/\\\//g, "/");

  try {
    encryptedString = decodeURIComponent(encryptedString);
  } catch (e) {}

  const parts = encryptedString.split(":");
  if (parts.length !== 2) {
    throw new Error("Invalid encrypted string format. Expected 'iv:ciphertext'.");
  }

  const [ivBase64, encryptedData] = parts;
  const key = CryptoJS.enc.Utf8.parse(ENCRYPTION_KEY.padEnd(32, "0"));
  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  const ciphertext = CryptoJS.enc.Base64.parse(encryptedData);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext },
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const text = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(text);
}

